// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3TCDF","alert":"SettungsInbox_alert__Fp3P-"};